import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import snakecaseKeys from 'snakecase-keys';
import {
  createAnnualGratificationSettingsRequest,
  updateAnnualGratificationSettingsRequest
} from '../../requests/annualGratificationSettings';
import { sendAlert } from '../../actions/utils';
import AnnualGratificationSettingsForm from './Annual/AnnualGratificationSettingsForm';

export const yearOptions = () => {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) => ({
    label: `${currentYear - i}`,
    value: currentYear - i
  }));
  return years;
};

const PayrollSettings = () => {
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();
  const handleSubmit = (values, setSubmitting, setFieldValue) => {
    setIsLoading(true);
    setSubmitting(true);
    const formatedValues = snakecaseKeys(values);
    if (values?.annualGratificationSetting?.id) {
      updateAnnualGratificationSettingsRequest(values?.annualGratificationSetting?.id, {
        dispatch,
        params: formatedValues,
        successCallback: () => {
          dispatch(sendAlert({ kind: 'success', message: 'Ajustes actualizados correctamente' }));
          setIsLoading(false);
          setSubmitting(false);
        },
        failureCallback: () => {
          setIsLoading(false);
          setSubmitting(false);
        },
        callback: () => {
          setIsLoading(false);
          setSubmitting(false);
        }
      });
      return;
    }

    createAnnualGratificationSettingsRequest({
      dispatch,
      params: formatedValues,
      successCallback: ({ data }) => {
        dispatch(sendAlert({ kind: 'success', message: 'Ajustes creados correctamente' }));
        setFieldValue('annualGratificationSetting[id]', data?.id);
        setIsLoading(false);
        setSubmitting(false);
      },
      failureCallback: () => {
        setIsLoading(false);
        setSubmitting(false);
      },
      callback: () => {
        setIsLoading(false);
        setSubmitting(false);
      }
    });
  };

  return (
    <>
      <AnnualGratificationSettingsForm
        yearOptions={yearOptions}
        formRequest={handleSubmit}
        setIsLoading={setIsLoading}
        dispatch={dispatch}
        isLoading={isLoading}
      />
    </>
  );
};

export default PayrollSettings;
